module.exports = __webpack_public_path__ + "silver-medal-ee2dfa881749a1f884c710f3096bc1ab.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/silver-medal.png
// module id = ljxu
// module chunks = client